import React, { useCallback } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';
import { token } from '@atlaskit/tokens';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

export const CrossIconCloseButton: React.FC<{
	onClose: () => void;
	source: string;
}> = ({ onClose, source }) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleClick = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'dismiss',
				source,
			},
		}).fire();
		onClose();
	}, [onClose, createAnalyticsEvent, source]);

	return (
		<IconButton
			icon={(iconProps) => <CrossIcon {...iconProps} color={token('color.icon.inverse')} />}
			appearance="subtle"
			label={<FormattedMessage {...messages.dismiss} />}
			onClick={handleClick}
		/>
	);
};

const messages = defineMessages({
	dismiss: {
		id: 'modernize-changeboarding.cross-icon-close-button.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Label for a button that dismisses the onboarding message.',
	},
});
